import React from 'react';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { ShimmerWrapper } from '@vfgroup-oneplatform/foundation/Components/Shimmer';
import PropTypes from 'prop-types';

import VfView from '../VfView';

import styles from './Header.Styles';
import { headerLoadingConfig } from './LoadingConfigurations/HeaderLoading.config';

function Header(props) {
  if (props.children) {
    return props.children;
  }

  const Loader = props.loader ? (
    props.loader
  ) : (
    <ShimmerWrapper isLoading={props.isLoading} loadingConfig={headerLoadingConfig} />
  );

  return (
    <VfView
      style={{ ...styles.MonthlyBillHeaderRoot, ...props.style }}
      justify="center"
      alignItems="center"
    >
      {props.isLoading ? (
        Loader
      ) : (
        <VfView xs={11}>
          <VFText style={styles.title} i18nKey={`${props.title}`} />
          <VFText style={styles.subTitle} i18nKey={`${props.subTitle}`} />
        </VfView>
      )}
    </VfView>
  );
}

Header.propTypes = {
  style: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  title: PropTypes.string,
  subTitle: PropTypes.string,
  children: PropTypes.node,
  isLoading: PropTypes.bool,
  loader: PropTypes.node,
};

export default Header;
